import React from 'react';
import Loading from './../misc/Loading';
import MakeList from './MakeList';
import makes from './../../../../model/makes';

class NewCarInformationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      makes: []
    };

    document.title = 'Admin - Nybilinformasjon - Merker';
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    const depth = 1;
    makes.all(depth).then((makes) => {
      this.setState({
        makes: makes
      });
    });
  }

  render() {
    if (this.state.makes.length > 0) {
      return (
        <section>
          <h1 className="page-header">Nybilinformasjon</h1>

          <MakeList makes={this.state.makes} />
        </section>
      );
    }

    return (
      <Loading title="Nybilinformasjon" text="Laster bilmerker" />
    );
  }
}

export default NewCarInformationComponent;
